(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtf-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-dtfh]');
  if(!root)return;

  // rotating strip
  var track=root.querySelector('[data-strip]');
  if(track){
    var msgs=track.querySelectorAll('.dtfh-strip__msg');
    if(msgs.length>1){
      var i=0;
      setInterval(function(){
        msgs[i].classList.remove('is-active');
        i=(i+1)%msgs.length;
        msgs[i].classList.add('is-active');
      },4200);
    }
  }

  // search toggle
  var sTog=root.querySelector('[data-search-toggle]');
  var sBox=root.querySelector('[data-search]');
  var sResults=root.querySelector('[data-search-results]');
  function openSearch(o){
    if(!sBox)return;
    sBox.hidden=!o;
    sTog.setAttribute('aria-expanded',o?'true':'false');
    if(o){var inp=sBox.querySelector('input');inp&&inp.focus();}
    else if(sResults){sResults.hidden=true;sResults.innerHTML='';}
  }
  sTog&&sTog.addEventListener('click',function(){openSearch(sBox.hidden);});
  var sClose=root.querySelector('[data-search-close]');
  sClose&&sClose.addEventListener('click',function(){openSearch(false);});

  // predictive search (Shopify suggest API)
  var sInput=root.querySelector('[data-search-input]');
  var sTimer,sCtl,sHl=-1;
  var POPULAR=[
    {t:'Order Transfers by Size',u:'/products/dtf-transfers'},
    {t:'Build a Gang Sheet',u:'/products/dtf-transfers-build-a-gang-sheet'},
    {t:'Ready to Press designs',u:'/collections/ready-to-press'},
    {t:'Mississippi State',u:'/collections/mississippi-state'}
  ];
  var TAG_SVG='<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 4h7l9 9-7 7-9-9V4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/></svg>';
  function money(v){var n=parseFloat(v);return isNaN(n)||n<=0?'':'From $'+n.toFixed(2);}
  function esc(s){return String(s).replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});}
  function show(html){ if(sResults){sResults.innerHTML=html;sResults.hidden=false;sHl=-1;} }
  function hideResults(){ if(sResults){sResults.hidden=true;sResults.innerHTML='';sHl=-1;} }

  function popularHtml(){
    return '<div class="dtfh-sr-head">Popular</div>'+POPULAR.map(function(x){
      return '<a class="dtfh-sr-item" href="'+x.u+'"><span class="dtfh-sr-thumb">'+TAG_SVG+'</span><span><span class="dtfh-sr-item__t">'+esc(x.t)+'</span></span></a>';
    }).join('');
  }
  function renderResults(R,q){
    var cols=R.collections||[], prods=R.products||[];
    if(!cols.length && !prods.length){
      show('<div class="dtfh-sr-empty"><strong>No matches for &ldquo;'+esc(q)+'&rdquo;</strong><br>Try a design theme, or start a transfer:'
        +'<div class="dtfh-sr-ctas"><a class="dtfh-sr-cta dtfh-sr-cta--fill" href="/products/dtf-transfers">Order Transfers</a>'
        +'<a class="dtfh-sr-cta dtfh-sr-cta--ghost" href="/products/dtf-transfers-build-a-gang-sheet">Build a Gang Sheet</a></div></div>');
      return;
    }
    var html='';
    if(cols.length){
      html+='<div class="dtfh-sr-head">Collections</div>'+cols.slice(0,4).map(function(c){
        return '<a class="dtfh-sr-item" href="'+c.url+'"><span class="dtfh-sr-thumb">'+TAG_SVG+'</span><span><span class="dtfh-sr-item__t">'+esc(c.title)+'</span><span class="dtfh-sr-item__meta">Collection</span></span></a>';
      }).join('');
    }
    if(prods.length){
      html+='<div class="dtfh-sr-head">Products</div>'+prods.slice(0,6).map(function(p){
        var img=(p.featured_image&&p.featured_image.url)||p.image||'';
        var thumb=img?'<img src="'+img+(img.indexOf('?')>-1?'&':'?')+'width=88" alt="" loading="lazy">':'<span class="dtfh-sr-thumb"></span>';
        var price=money(p.price);
        return '<a class="dtfh-sr-item" href="'+p.url+'">'+thumb+'<span><span class="dtfh-sr-item__t">'+esc(p.title)+'</span>'+(price?'<span class="dtfh-sr-item__p">'+price+'</span>':'')+'</span></a>';
      }).join('');
    }
    html+='<a class="dtfh-sr-all" href="/search?q='+encodeURIComponent(q)+'">See all results for &ldquo;'+esc(q)+'&rdquo; &rarr;</a>';
    show(html);
  }
  function doSuggest(q){
    if(sCtl)sCtl.abort();
    sCtl=('AbortController'in window)?new AbortController():null;
    show('<div class="dtfh-sr-loading">Searching&hellip;</div>');
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title',{signal:sCtl?sCtl.signal:undefined})
      .then(function(r){return r.json();})
      .then(function(j){ renderResults((j.resources&&j.resources.results)||{},q); })
      .catch(function(err){ if(err&&err.name==='AbortError')return; hideResults(); });
  }
  sInput&&sInput.addEventListener('input',function(){
    var q=sInput.value.trim();
    clearTimeout(sTimer);
    if(q.length<2){ show(popularHtml()); return; }
    sTimer=setTimeout(function(){doSuggest(q);},200);
  });
  sInput&&sInput.addEventListener('focus',function(){
    if(sInput.value.trim().length<2) show(popularHtml());
  });
  // keyboard navigation
  sInput&&sInput.addEventListener('keydown',function(e){
    if(!sResults||sResults.hidden)return;
    var rows=sResults.querySelectorAll('.dtfh-sr-item,.dtfh-sr-all,.dtfh-sr-cta');
    if(!rows.length)return;
    if(e.key==='ArrowDown'||e.key==='ArrowUp'){
      e.preventDefault();
      if(sHl>-1&&rows[sHl])rows[sHl].classList.remove('is-hl');
      sHl=e.key==='ArrowDown'?(sHl+1)%rows.length:(sHl<=0?rows.length-1:sHl-1);
      rows[sHl].classList.add('is-hl');
      rows[sHl].scrollIntoView({block:'nearest'});
    } else if(e.key==='Enter'){
      if(sHl>-1&&rows[sHl]){e.preventDefault();window.location.href=rows[sHl].getAttribute('href');}
    }
  });

  // cart drawer (open theme's native slide-out)
  var cartBtn=root.querySelector('[data-cart-open]');
  cartBtn&&cartBtn.addEventListener('click',function(e){
    if(document.getElementById('cart-drawer')){
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }
  });

  // drawer
  var drawer=root.querySelector('[data-drawer]');
  var burger=root.querySelector('[data-drawer-open]');
  function openDrawer(o){
    if(!drawer)return;
    drawer.hidden=!o;
    burger&&burger.setAttribute('aria-expanded',o?'true':'false');
    document.documentElement.style.overflow=o?'hidden':'';
  }
  burger&&burger.addEventListener('click',function(){openDrawer(true);});
  root.querySelectorAll('[data-drawer-close]').forEach(function(el){
    el.addEventListener('click',function(){openDrawer(false);});
  });

  // accordion
  root.querySelectorAll('.dtfh-acc__btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var body=btn.nextElementSibling;
      var open=body.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){openSearch(false);openDrawer(false);}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtf-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!('IntersectionObserver' in window))return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function init(){
    if(!document.querySelector('.dtf-home'))return;
    var sel=[
      '.dtf-home .tools__head','.dtf-home .lead__grid',
      '.dtf-home .pro','.dtf-home .showcase__body','.dtf-home .showcase__card',
      '.dtf-home .value > *','.dtf-home .cap',
      '.dtf-home .process__head','.dtf-home .process__media','.dtf-home .process__step',
      '.dtf-home .rtp-card','.dtf-home .msu','.dtf-home .lc'
    ].join(',');
    var els=document.querySelectorAll(sel);
    if(!els.length)return;
    document.body.classList.add('dtf-reveal-on');
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.06});
    els.forEach(function(el){
      el.classList.add('dtfr');
      // stagger siblings within the same parent for a cascade
      var sibs=el.parentElement?el.parentElement.children:[];
      var idx=Array.prototype.indexOf.call(sibs,el);
      el.style.transitionDelay=(Math.min(idx>=0?idx:0,4)*55)+'ms';
      io.observe(el);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
